import React from "react";
import FeatureSection from "./f-card/fcard_continer";
import Footer from "./footer/footer";
import FrontImage from "./landing-screen/front_image";
import NavBar from "./nav_bar";
import ScrollSec from "./scroll-feat/scrollFeat";

function FirstPage({List1hook,updateList1Hook,List2hook,updateList2Hook,List3hook,updateList3Hook,List4hook,updateList4Hook,Mainlisthook,updateMainlisthook,route1,updateroute1,route2,updateroute2,route3,updateroute3,route4,updateroute4 }){


    return (
        <div></div>


    );
}
export default FirstPage;